import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  Table as TableMaterial,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
} from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';

import EditIcon from '@material-ui/icons/Edit';
import moment from 'moment';
import 'moment/locale/th';
moment().locale('th');

const TableQuestions = ({ data }) => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const queryData = data.filter(
      (user) => user.status !== 'รอการตรวจสอบ' && user.status !== 'ส่งคำตอบแล้ว'
    );
    setUsers(queryData);
  }, [data]);

  const checkStatus = (text) => {
    if (text === 'ชำระเงินแล้ว') {
      return (
        <Chip
          label="รอคำตอบ"
          color="secondary"
          style={{ color: 'white', backgroundColor: red[700] }}
        />
      );
    } else if (text === 'มีคำตอบแล้ว') {
      return (
        <Chip
          label={text}
          style={{ color: 'white', backgroundColor: green[700] }}
        />
      );
    }
    return;
  };

  const getQuestion = () => {
    const callQuestions = users.filter((user) => user.status === 'ชำระเงินแล้ว')
      .length;
    return callQuestions;
  };

  return (
    <TableContainer component={Paper}>
      <TableMaterial style={{ minWidth: 700 }}>
        <caption>
          <span style={{ float: 'right' }}>
            มี {getQuestion()} คำถามที่ยังไม่ตอบ
          </span>
        </caption>
        <TableHead>
          <TableRow>
            <TableCell>ชื่อ-สกุล</TableCell>
            <TableCell align="center">รูปแบบ</TableCell>
            <TableCell align="center">สถานะ</TableCell>
            <TableCell align="center">จัดการ</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.id}>
              <TableCell component="th" scope="row">
                {user.fullname}
              </TableCell>
              <TableCell align="center">
                {user.promotion === 'promotion1'
                  ? 'โปร 3 คำถาม'
                  : 'โปร 5 คำถาม'}
              </TableCell>
              <TableCell align="center">{checkStatus(user.status)}</TableCell>
              <TableCell align="center">
                <Link to={`/questions/${user.id}`}>
                  <IconButton aria-label="edit">
                    <EditIcon />
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </TableMaterial>
    </TableContainer>
  );
};

export default TableQuestions;
